/**
 * Translations - Romanian (RO) and English (EN)
 */

export const translations = {
  ro: {
    // App
    appTitle: 'Calculator Dobândă',
    appSubtitle: 'Calculează-ți investițiile și descoperă puterea dobânzii',
    
    // Hero
    heroTitle: 'Calculator Dobândă',
    heroSubtitle: 'Planifică-ți viitorul financiar. Descoperă cum investițiile regulate și timpul pot transforma economiile tale în avere.',
    ctaButton: 'Calculează acum',
    
    // Navigation
    calculator: 'Calculator',
    results: 'Rezultate',
    comparison: 'Comparație',
    
    // Theme & Language
    darkMode: 'Mod întunecat',
    lightMode: 'Mod luminos',
    language: 'Limba',
    
    // Inputs
    initialDeposit: 'Depozit inițial',
    monthlyContribution: 'Contribuție lunară',
    annualInterestRate: 'Rata dobânzii anuale',
    investmentPeriod: 'Perioada (ani)',
    compoundingFrequency: 'Frecvența compunerii',
    contributionFrequency: 'Frecvența contribuțiilor',
    investmentType: 'Tip investiție',
    includeTaxes: 'Include taxe',
    adminFee: 'Comision administrativ',
    adminFeePercent: 'Comision administrativ (%)',
    
    // Pause
    contributionPause: 'Pauză contribuții',
    enablePause: 'Activează pauza',
    pauseStartYear: 'An început pauză',
    pauseEndYear: 'An final pauză',
    pauseDescription: 'În această perioadă nu se mai fac depuneri, dar dobânda continuă să se acumuleze',
    
    // Frequency options
    monthly: 'Lunar',
    annually: 'Anual',
    quarterly: 'Trimestrial',
    semiannually: 'Semestrial',
    
    // Results
    results: 'Rezultate',
    finalValue: 'Valoare finală',
    totalContributions: 'Total contribuții',
    totalInterest: 'Dobândă câștigată',
    interestGross: 'Dobândă brută',
    interestNet: 'Dobândă netă',
    taxPaid: 'Impozit plătit',
    adminFeePaid: 'Comisioane plătite',
    effectiveReturn: 'Randament efectiv',
    
    // Chart
    chartTitle: 'Evoluția investiției',
    contributions: 'Contribuții',
    interest: 'Dobândă',
    total: 'Total',
    year: 'An',
    
    // Table
    breakdownTable: 'Defalcare pe ani',
    yearColumn: 'An',
    startBalance: 'Sold inițial',
    yearContributions: 'Contribuții',
    yearInterest: 'Dobândă',
    endBalance: 'Sold final',
    totalColumn: 'Total acumulat',
    exportCSV: 'Exportă CSV',
    exportPDF: 'Exportă PDF',
    paused: 'Pauză',
    
    // Strategy Comparison
    strategyComparison: 'Comparație strategii',
    strategy1: 'Strategia curentă',
    strategy2: 'Strategie alternativă',
    differentContribution: 'Contribuție diferită',
    alternativeContribution: 'Contribuție alternativă',
    difference: 'Diferență',
    youWouldLose: 'Ai pierde',
    youWouldGain: 'Ai câștiga',
    
    // Tax info
    taxDisclaimer: 'Simulare informativă. Consultați un specialist pentru situații specifice.',
    simpleInterest: 'Dobândă simplă',
    compoundInterest: 'Dobândă compusă',
    
    // Tooltips
    tooltipInitialDeposit: 'Suma pe care o investești la început',
    tooltipMonthlyContribution: 'Suma pe care o adaugi în fiecare lună',
    tooltipInterestRate: 'Rata anuală de dobândă sau randament estimat',
    tooltipPeriod: 'Durata investiției în ani',
    tooltipCompounding: 'Cât de des se calculează și adaugă dobânda',
    tooltipInvestmentType: 'Tipul de investiție determină modul de calcul al dobânzii',
    tooltipAdminFee: 'Comisionul anual reținut de administratorul fondului',
    tooltipPause: 'Perioada în care nu se mai fac contribuții, dar banii rămân investiți',
    
    // Validation
    enterValue: 'Introdu o valoare',
    minValue: 'Valoare minimă',
    maxValue: 'Valoare maximă',
  },
  
  en: {
    // App
    appTitle: 'Interest Calculator',
    appSubtitle: 'Calculate your investments and discover the power of interest',
    
    // Hero
    heroTitle: 'Interest Calculator',
    heroSubtitle: 'Plan your financial future. Discover how regular investments and time can transform your savings into wealth.',
    ctaButton: 'Calculate now',
    
    // Navigation
    calculator: 'Calculator',
    results: 'Results',
    comparison: 'Comparison',
    
    // Theme & Language
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    language: 'Language',
    
    // Inputs
    initialDeposit: 'Initial deposit',
    monthlyContribution: 'Monthly contribution',
    annualInterestRate: 'Annual interest rate',
    investmentPeriod: 'Period (years)',
    compoundingFrequency: 'Compounding frequency',
    contributionFrequency: 'Contribution frequency',
    investmentType: 'Investment type',
    includeTaxes: 'Include taxes',
    adminFee: 'Administrative fee',
    adminFeePercent: 'Administrative fee (%)',
    
    // Pause
    contributionPause: 'Contribution pause',
    enablePause: 'Enable pause',
    pauseStartYear: 'Pause start year',
    pauseEndYear: 'Pause end year',
    pauseDescription: 'During this period no contributions are made, but interest continues to accrue',
    
    // Frequency options
    monthly: 'Monthly',
    annually: 'Annually',
    quarterly: 'Quarterly',
    semiannually: 'Semi-annually',
    
    // Results
    results: 'Results',
    finalValue: 'Final value',
    totalContributions: 'Total contributions',
    totalInterest: 'Interest earned',
    interestGross: 'Gross interest',
    interestNet: 'Net interest',
    taxPaid: 'Tax paid',
    adminFeePaid: 'Fees paid',
    effectiveReturn: 'Effective return',
    
    // Chart
    chartTitle: 'Investment growth',
    contributions: 'Contributions',
    interest: 'Interest',
    total: 'Total',
    year: 'Year',
    
    // Table
    breakdownTable: 'Yearly breakdown',
    yearColumn: 'Year',
    startBalance: 'Start balance',
    yearContributions: 'Contributions',
    yearInterest: 'Interest',
    endBalance: 'End balance',
    totalColumn: 'Total accumulated',
    exportCSV: 'Export CSV',
    exportPDF: 'Export PDF',
    paused: 'Paused',
    
    // Strategy Comparison
    strategyComparison: 'Strategy comparison',
    strategy1: 'Current strategy',
    strategy2: 'Alternative strategy',
    differentContribution: 'Different contribution',
    alternativeContribution: 'Alternative contribution',
    difference: 'Difference',
    youWouldLose: 'You would lose',
    youWouldGain: 'You would gain',
    
    // Tax info
    taxDisclaimer: 'Informational simulation. Consult a specialist for specific situations.',
    simpleInterest: 'Simple interest',
    compoundInterest: 'Compound interest',
    
    // Tooltips
    tooltipInitialDeposit: 'The amount you invest initially',
    tooltipMonthlyContribution: 'The amount you add every month',
    tooltipInterestRate: 'Annual interest rate or estimated return',
    tooltipPeriod: 'Investment duration in years',
    tooltipCompounding: 'How often interest is calculated and added',
    tooltipInvestmentType: 'Investment type determines how interest is calculated',
    tooltipAdminFee: 'Annual fee charged by the fund administrator',
    tooltipPause: 'Period during which no contributions are made, but money remains invested',
    
    // Validation
    enterValue: 'Enter a value',
    minValue: 'Minimum value',
    maxValue: 'Maximum value',
  },
};

/**
 * Get translation function
 */
export const getTranslation = (language = 'ro') => {
  return (key) => translations[language]?.[key] || translations.ro[key] || key;
};
